// Dependency free on purpose: also imported by vite.config.ts to build the
// language redirect script (see languageRedirectScript.ts).

/** URL prefix of the Portuguese public pages ("/pt/pricing"). */
export const PT_PATH_PREFIX = "/pt";

/** Public route patterns, written without a language prefix. */
export const PUBLIC_ROUTE_PATHS = [
  "/",
  "/research",
  "/research/:ticker",
  "/pricing",
  "/help",
  "/changelog",
  "/articles",
  "/articles/:slug",
  "/help/trading-212",
  "/help/interactive-brokers",
  "/help/degiro",
  "/help/xtb",
  "/help/robinhood",
  "/terms",
  "/privacy",
  "/delete-account",
  "/login",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/unsubscribe",
] as const;
